<script setup>
import ParallaxBanner from "@/Components/ParallaxBanner.vue"
import { computed, ref } from "vue"
import SectionPosition from "@/Components/SectionPosition.vue"
import Accordion from "@/Components/Accordion.vue"
import FeedbackForm from "@/Components/FeedbackForm.vue"

const props = defineProps({
	page: Object,
	settings: Array
})
const banner = ref({
	image: props.page.image,
	title: props.page.title,
	subtitle: props.page.subtitle
})
</script>

<template>
	<Page :description="page.title" :image="page.image" :title="page.name">
		<ParallaxBanner :item="banner" />
		<div class="relative bg-white">
			<div class="w-container padding-y">
				<div v-for="(item, index) in page.blocks" :key="index">
					<SectionPosition v-if="item && item.type === 'text-text' && item.data.is_active" :position="'left-center'">
						<template v-if="item.data.title" v-slot:left-subtitle>{{ item.data.subtitle }}</template>
						<template v-slot:left-content></template>
						<template v-slot:right>
							<div class="max-w-2xl">
								<p v-if="item.data.title" class="heading-xl mb-5 font-heading">{{ item.data.title }}</p>
								<p v-if="item.data.content" v-html="item.data.content"></p>
							</div>
						</template>
					</SectionPosition>
				</div>

				<!--				<div v-for="(item, index) in page.bricks" :key="index">-->
				<!--					<SectionPosition v-if="item && item.type === 'text-accordion'" :position="'left-center'">-->
				<!--						<template v-slot:left-subtitle>{{ item.data.subtitle }}</template>-->
				<!--						<template v-slot:left-content>-->
				<!--							<p>{{ item.data.excerpt }}</p>-->
				<!--						</template>-->
				<!--						<template v-slot:right>-->
				<!--							<Accordion v-if="item.data.team">-->
				<!--								<template v-slot:title>{{ item.data.title }}</template>-->
				<!--								<template v-slot:content>-->
				<!--									<div v-for="(t, i) in item.data.team" :key="i" class="mb-3 px-5">-->
				<!--										<div class="relative w-[250px] overflow-hidden rounded-full">-->
				<!--											<img :src="'/storage/' + t.image" alt="" class="relative z-20 mb-1 overflow-hidden rounded-full object-contain" />-->
				<!--											<div class="absolute bottom-1 left-1/2 z-10 aspect-square w-[250px] -translate-x-1/2 rounded-full bg-accent"></div>-->
				<!--										</div>-->
				<!--										<div class="ml-10 text-xl">-->
				<!--											<p class="font-semibold">{{ t.name }}</p>-->
				<!--											<p class="text-sm">{{ t.position }}</p>-->
				<!--										</div>-->
				<!--									</div>-->
				<!--								</template>-->
				<!--							</Accordion>-->
				<!--						</template>-->
				<!--					</SectionPosition>-->
				<!--				</div>-->
			</div>
			<div class="w-container padding-y">
				<div v-for="(item, index) in page.blocks">
					<SectionPosition v-if="item && item.type === 'vacancy' && item.data.is_active" :position="'left-center'">
						<template v-if="item.data.title" v-slot:left-subtitle>{{ item.data.title }}</template>
						<template v-slot:left-content>
							<p v-if="item.data.excerpt">{{ item.data.excerpt }}</p>
						</template>
						<template v-slot:right>
							<a v-if="item.data.url && item.data.url_name" :href="item.data.url" class="inline-block text-2xl font-semibold underline md:text-3xl xl:text-5xl" target="_blank">
								{{ item.data.url_name }}
							</a>
						</template>
					</SectionPosition>
				</div>
			</div>
			<div class="padding-y">
				<div v-for="(item, index) in page.bricks" :key="index">
					<template v-if="item && item.type === 'text-accordion' && item.data.is_active">
						<template v-if="item.data.team">
							<div class="w-container">
								<SectionPosition :position="'left-center'" class="mb-10">
									<template v-slot:left-subtitle>
										<p v-if="item.data.subtitle" class="">{{ item.data.subtitle }}</p>
									</template>
									<template v-slot:left-content>
										<p v-if="item.data.excerpt">{{ item.data.excerpt }}</p>
									</template>
									<template v-slot:right>
										<Accordion v-if="item.data.team">
											<template v-if="item.data.title" v-slot:title>{{ item.data.title }}</template>
											<template v-slot:content>
												<!--												<div class="grid grid-cols-1 gap-5 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-3">-->
												<div v-if="item.data.team.length > 0" class="flex w-fit flex-col">
													<div
														v-for="(t, i) in item.data.team"
														:key="i"
														:data-aos-delay="300"
														class="relative flex max-w-[410px] flex-col justify-between bg-gray-50 px-5 py-5"
														data-aos="fade"
														data-aos-duration="1000"
														data-aos-once="true"
													>
														<div class="absolute inset-x-0 top-0 h-1 bg-accent"></div>
														<div class="mb-3 text-center">
															<p v-if="t.name" class="text-xl font-semibold">{{ t.name }}</p>
															<p v-if="t.position" class="line-clamp-3 h-[60px] leading-[20px]">
																{{ t.position }}
															</p>
														</div>
														<div class="relative flex items-end justify-center">
															<img
																v-if="t.image"
																:src="'/storage/' + t.image"
																alt=""
																class="relative z-20 aspect-square overflow-hidden rounded-full bg-accent object-cover object-top lg:h-[250px] lg:bg-transparent xl:h-[290px] 2xl:h-[300px]"
															/>
															<div v-if="t.image" class="absolute bottom-1 left-1/2 z-10 hidden aspect-square w-[80%] -translate-x-1/2 rounded-full bg-accent lg:block"></div>
														</div>
													</div>
												</div>
												<!--												</div>-->
											</template>
										</Accordion>
									</template>
								</SectionPosition>
							</div>
						</template>
					</template>
				</div>
			</div>
			<!--			<FeedbackForm :contacts="getContacts" />-->
		</div>
	</Page>
</template>

<style scoped></style>
